import axios from 'axios';
import Config from '../Helpers/Config';
import uniqueId from 'lodash/uniqueId'
import {requiresRelogin}  from './authActions'

export const fetch = (businessId, productHashId) => {
    return function (dispatch) {
        dispatch({
            type: 'FETCHING_EDIT_PRODUCT_FORM'
        });
        return axios.get(`${Config.api()}products/find-template/${businessId}/${productHashId}?do=update`, {
            withCredentials: Config.withCredentials()
        })
            .then((response) => {


                if(!response.data.images){
                    response.data.images = [];
                }

                response.data.images = response.data.images.map((image, index) => {
                    return {
                        id: uniqueId(),
                        name: image,
                        path: image,
                        preview: 'https://cdn1.shooq.co.il/data/full/' + image,

                    };
                });

                const namesTypes = {};

                response.data.attributes = response.data.attributes.map((group) => {
                    group.properties = group.properties.filter((attribute)=>{
                        namesTypes[attribute.name] = attribute.data_type
                        return attribute.is_variant === false
                    });
                    return group
                }).filter((group)=>{
                    return group.properties.length > 0
                });

                response.data.properties.forEach((group) => {
                    group.attributes.forEach((attr) => {
                        if(attr.value){
                            response.data[attr.name] = attr.value
                        }else{
                            if(namesTypes[attr.name] === 'dropdown'){
                                response.data[attr.name] = -1;
                                response.data[attr.name + '_other'] = attr.value_text
                            }else{
                                response.data[attr.name] = attr.value_text
                            }
                        }
                    });
                });


                dispatch({
                    type: 'FETCH_EDIT_PRODUCT_FORM',
                    results: response.data
                });

                let variants = [];
                response.data.attributes.forEach(function (group, index) {
                    group.properties.forEach(function (item, index) {
                        if (item.is_variant === true) {
                            variants.push(item.name);
                        }
                    })
                });
                dispatch({
                    type: 'EDIT_PRODUCT_UPDATE_VARIANT_INDEXES',
                    variants: variants
                });
            }).catch((error) => {
                console.log(error)
                if(error.response.status === 401) {
                    dispatch(requiresRelogin(true, true))
                }else{
                    dispatch({
                        type: 'FETCHING_EDIT_PRODUCT_FORM_FAILED'
                    });
                }
            });
    };
};

export const requireVariantUpdate = (bool) => {
    return {
        type: 'EDIT_PRODUCT_FORM_REQUIRE_VARIANT_UPDATE',
        status: bool
    }
};

export const updateImages = (images) => {
    return {
        type: 'EDIT_PRODUCT_FORM_UPDATE_IMAGES',
        images: images
    }
};
